<template>
  <v-main>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col>
          <v-card class="mx-auto" max-width="600px">
            <v-toolbar color="secondary" dark>
              <v-toolbar-title>{{ title }}</v-toolbar-title>
              <v-btn color="secondary" class="ma-2" fab x-small @click="openInfo">
                <v-icon>mdi-information-variant</v-icon>
              </v-btn>
              <v-spacer></v-spacer>
              <Condition/>
            </v-toolbar>
            <ConditionsView/>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <Information ref="info" />
  </v-main>
</template>

<script>
import Information from "@/components/dialogs/Information";
import ConditionsView from "@/components/views/ConditionsView";
import Condition from "@/components/dialogs/Condition";
export default {
  name: "Medications",
  components: {
    ConditionsView,
    Condition,
    Information
  },
  events: {
    callToggle() {
      this.toggleComp();
    }
  },
  data: () => ({
    dialog: false,
    valid: true,
    component: ConditionsView,
    title: "Your Conditions",
    btnTitle: "Edit",
    dialogMessage: {
      title: "About Conditions",
      text: [
        "Medication conditions",
        "You can add medical conditions that you have been diagnosed with",
        "Select a condition from the list of in the drop down list"
      ]
    }
  }),
  methods: {

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("user/aAddProfile", this.profile).then(res => {
          if (res) {
            this.dialog = false;
          }
        });
      }
    },
    openInfo() {
      this.$refs.info.openDialog(this.dialogMessage);
    }
  }
}
</script>

<style>
</style>